import { ReactNode, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { logout } from 'src/features/Auth';

interface URLInterceptorProps {
  children: ReactNode;
}

const URLInterceptor: React.FC<URLInterceptorProps> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleUrl = async () => {
      const searchParams = new URLSearchParams(location.search);
      const token = searchParams.get('token');
      const isTrackingReport = searchParams.get('istrackingreport');
      const openAirplayReport = searchParams.get('openairplayreport');

      // Always log out the user if a token is present in the URL on specific routes (caster redirection)
      if (token && location.pathname === `/payment/multiasset`) {
        await logout();
        // Redirect and keep the token in the URL
        navigate(
          `/auth/signin?token=${token}&istrackingreport=${isTrackingReport}&openairplayreport=${openAirplayReport}`,
          { replace: true }
        );
      }
      // Add other URL handling logic as needed
    };

    handleUrl();
  }, [location, navigate]);

  // eslint-disable-next-line react/react-in-jsx-scope
  return <>{children}</>; // Correctly return a React element (JSX)
};

export default URLInterceptor;
